import { render, staticRenderFns } from "./AssessFormPage.vue?vue&type=template&id=700965b2&scoped=true&"
import script from "./AssessFormPage.vue?vue&type=script&lang=js&"
export * from "./AssessFormPage.vue?vue&type=script&lang=js&"
import style0 from "./AssessFormPage.vue?vue&type=style&index=0&id=700965b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700965b2",
  null
  
)

export default component.exports